import { Factory } from 'miragejs'
import { format, subMonths, addMonths, isAfter } from 'date-fns'

export default Factory.extend({
  // The backend provides date as yyyy-MM-dd date (technically ISO8601 shorthand), so this is what the factory prodivdes
  startDate() {
    const past = subMonths(new Date(), 1)
    return format(past, 'yyyy-MM-dd')
  },
  endDate() {
    const future = addMonths(new Date(), 1)
    return format(future, 'yyyy-MM-dd')
  },
  // this logic isn't exactly the same as backend - their date comparisons are UTC and likely coerce the date comparison
  // to be dates (ignoring time), inclusive of start/end date. Approximate is good enough for our tests.
  status() {
    const now = new Date()
    const start = new Date(this.startDate)
    const end = new Date(this.endDate)
    if (isAfter(now, end)) return 'expired'
    if (isAfter(now, start)) return 'active'
    return 'pending'
  },
})
